const queryKeys = {
  SWEEPS: "sweeps",
  CURRENT_SWEEPS_REPORT: "current_sweeps_report",
  PAST_SWEEPS_REPORT: "past_sweeps_report",
};

export default queryKeys;
